import React from "react";
import { useSelector } from "react-redux";
import { Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import i18n from "../../i18n";
import FOOTER_LINKS from "../../constants/footer.const";
import SocialIcon from "./social";
import constant from '../../config/index.json';

const { VITE_REDIRECT_TO_OLD_URL } = import.meta.env;

const useStyles = makeStyles((theme) => ({
  footerLinks: {
    padding: theme.spacing(0),
    "& a": {
      color: "#ffffff",
      textDecoration: "none",
      lineHeight: 2,
    },
    "& a:hover": {
      textDecoration: "underline",
    },
  },
  footerList: {
    listStyle: "none",
  },
  title: {
    fontSize: theme.spacing(1.5),
    color: "#ffffff",
  },
}));

const Links = ({ footerLinks, showHelp }) => {
  const classes = useStyles();

  const removeSpace = (item) => item.replace(" ", "");

  const handleClick = (e, path) => {
    e.preventDefault();
    showHelp(path);
  };
  // Extract orgID and country from the Redux state (authentication.user)
  const {
    CP_ORGID: orgID,
    CP_COUNTRY: country,
    REGION: region,
  } = useSelector((state) => state?.authentication?.user || {});

  const isSRLyonEnable = useSelector((state) => state.authentication?.isSRLyonEnable ?? false);

  // Function to determine which footer links to show based on orgID and country
  // orgId 116 is for NA region and 107 for APAC region
  const getFooterLinks = () => {
      if (region === constant?.country?.EU) {
          // EU but NOT org 119
          if (orgID !== "119") {
            return {
              left: FOOTER_LINKS.getLeftLinksEU(isSRLyonEnable),
              right: FOOTER_LINKS.getRightLinksEU(),
            };
          }
          return {
            left: FOOTER_LINKS.getLeftLinksEU119(isSRLyonEnable),
            right: FOOTER_LINKS.getRightLinksEU119(),
          };
        }
    if (orgID === "116" && country === "CA") {
      return {
        left: FOOTER_LINKS.getLeftLinks116CA(),
        right: FOOTER_LINKS.getRightLinks(),
      };
    } else if (orgID === "116") {
      return {
        left: FOOTER_LINKS.getLeftLinks116(),
        right: FOOTER_LINKS.getRightLinks(),
      };
    } else if (orgID === "107") {
      if (["AU", "NZ"].includes(country)) {
        return {
          left: FOOTER_LINKS.getLeftLinksAUSNZ(),
          right: FOOTER_LINKS.getRightLinks107AP(),
        };
      } else if (["SG", "MY"].includes(country)) {
        return {
          left: FOOTER_LINKS.getLeftLinksSGMY(),
          right: FOOTER_LINKS.getRightLinks107AP(),
        };
      } else {
        return {
          left: FOOTER_LINKS.getLeftLinks107AP(),
          right: FOOTER_LINKS.getRightLinks107AP(),
        };
      }
    } else {
      return {
        left: FOOTER_LINKS.getLeftLinks(),
        right: FOOTER_LINKS.getRightLinks(),
      };
    }
  };
  const { left: leftLinks, right: rightLinks } = getFooterLinks();

  return (
    <>
      <div className={classes.footerLinks}>
        <Grid container spacing={0}>
          <Grid item xs={6} md={5}>
            <ul className={classes.footerList}>
              <li>
                <Typography variant="subtitle2" className={classes.title}>
                  {i18n.t("footer.resmedOnlineStore")}
                </Typography>
              </li>
              {leftLinks?.length &&
                leftLinks.map((element, index) => (
                  <li key={index}>
                    <a
                      href={element?.link}
                      onClick={(e) => handleClick(e, element?.link)}
                      id={`Footer-LNK-${removeSpace(element?.linkId)}`}
                      target={element?.target || "_self"}
                      rel="noopener noreferrer"
                    >
                      {i18n.t(element?.linkCaption)}
                    </a>
                  </li>
                ))}
            </ul>
          </Grid>

          <Grid item xs={6} md={3}>
            <ul className={classes.footerList}>
              <li>
                <Typography variant="subtitle2" className={classes.title}>
                  {i18n.t("footer.company")}
                </Typography>
              </li>
              {rightLinks?.length &&
                rightLinks.map((element, index) => {
                  const elementId = element?.id
                    ? element.id
                    : `Footer-LNK-${removeSpace(i18n.t(element?.linkId))}`;

                  return (
                    <li key={index}>
                      {element?.internal ? (
                        <Link to={element.link} id={elementId}>
                          {i18n.t(element?.linkCaption)}
                        </Link>
                      ) : (
                        <a
                          href={element?.link}
                          target={element?.target}
                          rel="noopener noreferrer"
                          id={elementId}
                        >
                          {i18n.t(element?.linkCaption)}
                        </a>
                      )}
                    </li>
                  );
                })}
            </ul>
          </Grid>
          <Grid item xs={12} md={4} className="copyright">
            <ul className={classes.footerList}>
              <li>
                <Typography variant="subtitle2" className={classes.title}>
                  {i18n.t("footer.connect")}
                </Typography>
              </li>
            </ul>
            <SocialIcon />
            <span id="Footer-LNK-Copy-Rights">
              {i18n.t("footer.copyRight")} |{" "}
            </span>
            <a
              href="#"
              id="Footer-LNK-CookiePolicy"
              onClick={() =>
                showHelp(
                  `${VITE_REDIRECT_TO_OLD_URL}/help/terms_and_conditions_index.html?cookie_policy.html`
                )
              }
              rel="noopener noreferrer"
            >
              {i18n.t("footer.cookiePolicy")}
            </a>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default withTranslation()(Links);
